import FormRow from 'Components/FormRow';
import FormSection from 'Components/FormSection';
import { Container, Item } from 'Components/Grid';
import InputHandler from 'Components/InputHandler';
import OptionChooser from 'Components/OptionChooser';
import { IFormContext, withFormContext } from 'Containers/FormContextHandler';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { gafClasses } from 'Routes/InterviewSurveys/utils';
import colors from '../../../../../config/theme/colors';

const GAF = ({ formData, view /*, documents*/ }: IFormContext<IGAF>): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string, values?: { [key: string]: string | React.JSX.Element | (() => React.JSX.Element) }) =>
    formatMessage({ id }, values);

  const [selectedGAF, setSelectedGAF] = React.useState<boolean | null>(null);
  // If gafClass is changed, set gafValue to undefined
  React.useEffect(() => {
    // On component mount if gaf has been selected, set state to avoid clearing the value
    if (!selectedGAF && formData.document.gafClass) {
      setSelectedGAF(true);
      return;
    }

    if (formData.document.gafClass && (formData.document.gafValue || formData.document.gafValue === 0)) {
      formData.onChange && formData.onChange({ gafValue: undefined });
    }
  }, [formData.document.gafClass]);

  return (
    <React.Fragment>
      <div
        style={{
          paddingLeft: '1rem',
          fontStyle: 'italic',
          marginBottom: '2rem',
          color: colors.darkGray,
          whiteSpace: 'pre-line',
        }}
      >
        {fm('interviewSurveys.gaf.instructions', { br: '\n' })}
      </div>
      <FormSection>
        <FormRow title="general.date">
          <InputHandler
            type="PartialDate"
            editing={!view?.viewing}
            name="date"
            formData={formData}
            dateDefault="now"
            isNotCancellable
          />
        </FormRow>
        <FormRow title="interviewSurveys.gaf.gafValue">
          <OptionChooser
            name="gafClass"
            formData={formData}
            opts={gafClasses}
            optionFormatter={(name: string | number): React.JSX.Element => {
              if (typeof name === 'number') return <></>;
              const limits = name.split('-');
              return (
                <Container alignItems={'center'}>
                  <Item style={{ padding: '0 2rem', minWidth: '12rem' }}>
                    {formData.document.gafClass !== '0' && (
                      <InputHandler
                        type="NumberField"
                        editing={!view?.viewing && formData.document?.gafClass === name}
                        name="gafValue"
                        formData={{
                          onChange: formData.onChange,
                          document:
                            formData.document.gafClass === name
                              ? formData.document
                              : { ...formData.document, gafValue: undefined },
                        }}
                        precision={0}
                        width={8}
                        placeholder={`${name}`}
                        min={parseInt(limits[1])}
                        max={parseInt(limits[0])}
                        disablePlaceholderFormatting
                      />
                    )}
                  </Item>
                  <Item xs={true}>{fm(`interviewSurveys.opts.gaf.${name}`)}</Item>
                </Container>
              );
            }}
          />
        </FormRow>
      </FormSection>
      <FormSection>
        <div style={{ paddingLeft: '1rem', fontStyle: 'italic', color: colors.darkGray }}>
          American Psychiatric Association: Diagnostic and Statistical Manual of Mental Disorders, Fourth Edition.
          Washington, DC, American Psychiatric Association, 1994.
        </div>
      </FormSection>
    </React.Fragment>
  );
};

export default withFormContext(GAF);
